application.register("part_item_extranet_wishlist", class extends Stimulus.Controller {

    get target() {
        return {
            body: this.targets.find("body"),
        }
    }

    initialize() {
        importScript(cdnjs.slideElement)
    }

    toggle({currentTarget}) {
        if(currentTarget.getAttribute('aria-expanded') === 'true') {
            SlideElement.up(this.target.body, {
                duration: 300
            }).then(() => {
                currentTarget.setAttribute('aria-expanded', 'false');
                this.element.removeAttribute('data-open');
            })

        } else {
            SlideElement.down(this.target.body, {
                duration: 300
            }).then(() => {
                currentTarget.setAttribute('aria-expanded', 'true');
                this.element.setAttribute('data-open','');
            })
        }
    }
});
